export const MC_NUTRITIONAL_RISK_SCORE = {
    title: "nutritional-risk-score.title",
    masterTableName: "MC_NUTRITIONAL_RISK_SCORE",
    tableName: "MC_NUTRITIONAL_RISK_SCORE_DET",
    columnName: "NRS_ID",
    columnValue: 0,
    formData: {
        ID: "",
        NRS_ID: "",
        PROCESS_TIME: new Date(),
        CTIME: new Date(),
        CUSER: "",
        NURSE_ID: "",
        HEIGHT: 0,
        WEIGHT: 0,
        BODY_MASS_INDEX: 0,
        BODY_MASS_INDEX_SCORE: null,
        WEIGHT_LOSS: null,
        REDUCTION_FOOD_PURCHASE: null,
        ADVANCED_PATIENT: null,
        BODY_MASS_INDEX_SCORE_EXP: "",
        REDUCTION_FOOD_PURCHASE_EXP: "",
        WEIGHT_LOSS_TREE_MONTHS_EXP: "",
        ADVANCED_PATIENT_EXP: "",
        NORMAL_NUTRITION: 0,
        WEIGHT_LOSS_ONE_MONTHS: 0,
        WEIGHT_LOSS_TWO_MONTHS: 0,
        WEIGHT_LOSS_TREE_MONTHS: 0,
        NORMAL_NUTRITION_REQUIREMENT: 0,
        DISEASE_INTENSITY_ONE: 0,
        DISEASE_INTENSITY_TWO: 0,
        DISEASE_INTENSITY_TREE: 0,
        NUTRITIONAL_SCORE: 0,
        DISEASE_SCORE: 0,
        ASSESSMENT_SCORE: 0,
        OVER_SEVENTY: 0,
        RESULT_NOTE: "",
    },
    fields: [
        { field: "PROCESS_TIME", headerName: "nutritional-risk-score.columns.date", flex: 1, type: "date" },
        { field: "CUSER", headerName: "nutritional-risk-score.columns.nurse", flex: 1 },
        { field: "BODY_MASS_INDEX", headerName: "nutritional-risk-score.columns.vki", flex: 1 },
        { field: "ASSESSMENT_SCORE", headerName: "score", flex: 0.5 },
    ],
    rows: [
        { title: "id", value: "ID" },
        { title: "date", value: "PROCESS_TIME", type: "date" },
        { title: "CUSER", value: "CUSER" },
        { title: "BODY_MASS_INDEX", value: "BODY_MASS_INDEX" },
        { title: "ASSESSMENT_SCORE", value: "ASSESSMENT_SCORE" },
    ],
    mcpConfig: {} as Record<string, { mcpId: number; field: string; scoreField: string }>,
    extraMcpIds: [117]
};
